import { render, staticRenderFns } from "./mechanism.vue?vue&type=template&id=1f5b9d45&scoped=true"
import script from "./mechanism.vue?vue&type=script&lang=js"
export * from "./mechanism.vue?vue&type=script&lang=js"
import style0 from "./mechanism.vue?vue&type=style&index=0&id=1f5b9d45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5b9d45",
  null
  
)

export default component.exports